export default function store() {
  return {
    portal: {
    }
  };
}
